import { useEffect, useRef } from "react";
import { Eraser, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

function trim(c) {
  const g = c.getContext("2d");
  const { data, width, height } = g.getImageData(0, 0, c.width, c.height);
  let x0 = width, y0 = height, x1 = 0, y1 = 0;
  for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
    if (data[(y * width + x) * 4 + 3]) { x0 = Math.min(x0, x); y0 = Math.min(y0, y); x1 = Math.max(x1, x); y1 = Math.max(y1, y); }
  }
  if (x1 <= x0) return "";
  const o = document.createElement("canvas");
  o.width = x1 - x0 + 8; o.height = y1 - y0 + 8;
  o.getContext("2d").drawImage(c, x0 - 4, y0 - 4, o.width, o.height, 0, 0, o.width, o.height);
  return o.toDataURL("image/png");
}

export function SignaturePad({ onSave }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const fit = () => {
    const c = ref.current;
    if (c.width === c.offsetWidth * 2 && c.height === c.offsetHeight * 2) return;
    c.width = c.offsetWidth * 2; c.height = c.offsetHeight * 2;
    const g = c.getContext("2d");
    g.scale(2, 2); g.lineWidth = 2.4; g.lineCap = "round"; g.lineJoin = "round"; g.strokeStyle = "#111827";
  };
  useEffect(() => {
    const ro = new ResizeObserver(fit);
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  const pos = (e) => { const c = ref.current, r = c.getBoundingClientRect(); return [((e.clientX - r.left) * c.offsetWidth) / r.width, ((e.clientY - r.top) * c.offsetHeight) / r.height]; };
  const down = (e) => { fit(); drawing.current = true; ref.current.setPointerCapture(e.pointerId); const g = ref.current.getContext("2d"); g.beginPath(); g.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const g = ref.current.getContext("2d"); g.lineTo(...pos(e)); g.stroke(); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); };
  return (
    <div className="space-y-2">
      <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={() => { drawing.current = false; }}
        className="w-full h-36 rounded-md border border-dashed bg-white touch-none cursor-crosshair" data-testid="signature-pad-canvas" />
      <div className="flex gap-2">
        <Button size="sm" variant="ghost" onClick={clear} data-testid="signature-clear-button"><Eraser className="h-4 w-4 mr-1" />Clear</Button>
        <Button size="sm" variant="outline" onClick={() => onSave(trim(ref.current))} data-testid="signature-save-button"><Check className="h-4 w-4 mr-1" />Use drawn signature</Button>
      </div>
    </div>
  );
}
